import { useEffect } from "react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";

import { AuthenticationScreenContainer } from "@/components";
import { icons } from "@/ui";

const PasswordUpdated = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timeout = setTimeout(() => {
      navigate({ to: "/login" });
    }, 3000);

    return () => {
      clearTimeout(timeout);
    };
  }, [navigate]);

  return (
    <AuthenticationScreenContainer>
      <div className="flex h-full flex-col items-center justify-center gap-1 sm:gap-3">
        <icons.CheckCircleIcon className="mb-5 size-12 text-success sm:mt-5" />
        <h1 className="text-xl font-bold">Password updated</h1>

        <h2>You will be redirected in a few seconds</h2>
      </div>
    </AuthenticationScreenContainer>
  );
};

export const Route = createFileRoute("/_guest/password-updated/")({ component: PasswordUpdated });
